export default __webpack_public_path__ + "static/media/client-11.f9de98e9.png";